function roundMoney(v: number): number {
  return Math.round(v * 100) / 100;
}

/** Sell price from a margin that is a fraction of the sell price: cost / (1 - m). */
export function sellPriceFromMarginFraction(cost: number, marginFraction: number): number {
  if (!Number.isFinite(cost)) return 0;
  if (!Number.isFinite(marginFraction) || marginFraction <= 0) return roundMoney(cost);
  if (marginFraction >= 1) return roundMoney(cost);
  return roundMoney(cost / (1 - marginFraction));
}

/** `marginPercent` is percentage points (18 means 18%). */
export function sellPriceFromMarginPercent(cost: number, marginPercent: number): number {
  if (!Number.isFinite(marginPercent)) return sellPriceFromMarginFraction(cost, 0);
  return sellPriceFromMarginFraction(cost, marginPercent / 100);
}
